import MainLayout from "../../../components/MainLayout/MainLayout";
import Hero from "../container/Hero"
import HomePageCard from "../container/HomePageCard";
import LatestContent from "../container/LatestContent";
import ContinueWatchingRow from "../container/ContinueWatchingRow";
import StudioAndCommunityBand from "../container/StudioAndCommunityBand";
import CreativeVisionShowcase from "../container/CreativeVisionShowcase";
import useSEO from "../../../hooks/useSEO";

const HomePage = () => {
    // Apply enhanced SEO for home page
    useSEO({
        title: 'StrymHub \u2014 Independent Production Company & Streaming Home | Sheffield, UK',
        description: 'StrymHub is an independent production company based in Sheffield, UK. We write, cast and film original films, series and shows using a community-scouted in-house repertory, and stream them exclusively on our own platform. Open to brand partnerships and sponsored productions.',
        keywords: 'strymhub, independent production company, sheffield production company, indie film uk, original films, original series, in-house studio, sheffield filmmakers, brand partnerships, sponsored content, co-production, uk independent studio, streaming home, join the troupe, casting calls',
        type: 'website'
    });

    return (
        <MainLayout>
            <main id="main-content">
                <Hero />
                {/* Straight after the hero: for a returning viewer, picking up where they
                    left off is the most likely reason they came back. Renders nothing for
                    signed-out visitors or an empty history. */}
                <ContinueWatchingRow />
                <HomePageCard />
                <LatestContent />
                <StudioAndCommunityBand />
                <CreativeVisionShowcase />
            </main>
        </MainLayout>
    )
}

export default HomePage